import React from 'react';
import { Glyphicon } from 'react-bootstrap';
import Button from '../components/CustomButtons/Button.jsx';
import './LoaderButton.css';

export default ({ isLoading, text, loadingText, className = '', disabled = false, ...props }) => (
	<Button color="info" className={`LoaderButton ${className}`} disabled={disabled || isLoading} {...props}>
		{isLoading && <Glyphicon glyph="refresh" className="spinning" />}
		{!isLoading ? text : loadingText}
	</Button>
);



// WEBPACK FOOTER //
// ./src/custom-components/LoaderButton.js